import React from 'react';
import { Box, Alert } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import SEOHead from '../SEOHead';
import HomeHero from './HomeHero';
import HomeServicesSection from './HomeServicesSection';
import HomeOffersAndTrustSection from './HomeOffersAndTrustSection';
import { acme } from '../../theme/acmeTheme';

function Home() {
  const [searchParams] = useSearchParams();
  const showVerifiedBanner = searchParams.get('verified') === '1';

  return (
    <>
      <SEOHead pageName="home" />
      {showVerifiedBanner && (
        <Alert severity="success" sx={{ borderRadius: 0, justifyContent: 'center' }}>
          Email confirmed successfully!
        </Alert>
      )}
      <Box sx={{ overflowX: 'hidden', backgroundColor: acme.colors.pageBg }}>
        <HomeHero />
        <HomeServicesSection />
        <HomeOffersAndTrustSection />
      </Box>
    </>
  );
}

export default Home;
